import MedicationQuestionnaireInput from "./MedicationQuestionnaireInput"

type MedicationStringCreator =
    | string
    | ((info: MedicationQuestionnaireInput) => string)

function resolveString(
    creator: MedicationStringCreator,
    info: MedicationQuestionnaireInput
): string {
    if (typeof creator === "string") return creator
    else return creator(info)
}
export { resolveString }

export default MedicationStringCreator
